export default __webpack_public_path__ + "static/media/clock.f8e4bdfd.svg";